import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
	name: "date_native",
	standalone: false
})
export class DateNativePipe implements PipeTransform {
	transform(value: number | string | Date, format: Intl.DateTimeFormatOptions, locale: string = "eng"): string {
		if (typeof value === "string") {
			value = new Date(value);
		}
		return Intl.DateTimeFormat(locale, format).format(value);
	}
}
